import makeAjaxRequest from './make-ajax-request';
var loadSvgUncached = function (url, httpRequestWithCredentials, callback) {
    makeAjaxRequest(url, httpRequestWithCredentials, function (error, httpRequest) {
        if (error) {
            callback(error);
        }
        else if (httpRequest.responseXML instanceof Document &&
            httpRequest.responseXML.documentElement &&
            httpRequest.responseXML.documentElement instanceof SVGSVGElement) {
            callback(null, httpRequest.responseXML.documentElement);
        }
    });
};
export default loadSvgUncached;
//# sourceMappingURL=load-svg-uncached.js.map